import { deepLinkParamGetters } from '../../shared/utils/deepLinkUtils';
import { renderMustacheTemplateIfAllTemplateParametersArePresent } from '../../shared/utils/mustacheUtils';

/**
 * @param {Record<string, any>} slot
 */
const getMwsTemplateParameters = (slot) => {
  // gladstone identifiers look like SOME_URI/slots/ID_YEAR-MONTH-DAYTHOUR-MIN-SECZ
  // gladstone facade identifiers look like SOME_URI/facility-use-slots/ID_YEAR-MONTH-DAYTHOUR-MIN-SECZ
  // the below regex matches both gladstone and gladstone facade identifiers
  const { identifier } = slot;
  const result = identifier.match(/slots\/([^_]+)_(\d+-\d+-\d+)T/);
  // TODO: if the provider is not gladstone, a better solution is needed here
  if (!result) {
    return undefined;
  } else {
    const [, activityId, dateString] = result;
    return { activityId, dateString };
  }
};

/**
 * @param {Record<string, any>} slot
 * @param {Record<string, any>} facilityUse
 */
const getTemplateParameters = (slot, facilityUse) => {
  const params = {
    ...getMwsTemplateParameters(slot),
    ...deepLinkParamGetters.facilityUseRpdeId(facilityUse),
    ...deepLinkParamGetters.startDateIsoUtc(/** @type {any} */ (slot)),
  };
  return params;
};

/**
 * @param {string} provider
 * @param {Record<string, string>} memberDeepLinks
 * @param {object} args
 * @param {Record<string, any>} args.slot
 * @param {Record<string, any>} args.facilityUse
 * @returns {string | undefined}
 */
const getDeepLinkUrl = (provider, memberDeepLinks, { slot, facilityUse }) => {
  const deeplinkTemplate = memberDeepLinks[provider];
  if (!deeplinkTemplate) return undefined;

  const params = getTemplateParameters(slot, facilityUse);
  return renderMustacheTemplateIfAllTemplateParametersArePresent(deeplinkTemplate, params);
};

export { getDeepLinkUrl };
